import React from 'react';
import PropTypes from 'prop-types';

/**
 * Content - A wrapper that renders a standard HTML div element with Bulma content class names
 * 
 * This component accepts the same props as Bloomer Content for easy migration
 */
const Content = ({
  className = '',
  style = {},
  children = null,
  isSize = null,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['content'];
    
    // Add size class if specified
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <div 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

// eslint-disable-next-line react/require-default-props
Content.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  isSize: PropTypes.oneOf(['small', 'medium', 'large']),
};



export default Content;
